import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { registerServiceWorker } from './lib/offline-cache';
import { initPostHog } from './lib/posthog';
import { restoreSpaFallbackPath } from './lib/spa-fallback';
import './styles/app.css';

restoreSpaFallbackPath();
void registerServiceWorker();
initPostHog();

const root = document.getElementById('root');

if (!root) {
  throw new Error('Missing root element.');
}

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
